import { init as initApm } from '@elastic/apm-rum'
const apm = initApm({
    serverUrl: process.env.REACT_APP_APM_SERVER_URL,
    serviceName: process.env.REACT_APP_APM_SERVICE_NAME,
    environment: process.env.REACT_APP_APM_ENVIRONMENT,
    logLevel: process.env.REACT_APP_APM_LOG_LEVEL
})
export default apm;
